// The order of an article list (2026-10-04, Sam: "do I put it in recent
// order or use some algo?"). One rule for every list of a story's articles,
// the Headlines columns and the articles panel, with a label so the reader
// knows which it is.
//
// Default: popular (Sam, 2026-10-04). The most-read outlets first, one
// outlet per slot before any outlet repeats, live blogs last. Newest-first
// is the toggle: it answers "what just came in" and nothing else, and on a
// 90-article story it puts the latest aggregator rewrite above the original
// reporting.

export const ORDERS = [
  {
    id: 'popular',
    label: 'Popular',
    title: 'Most-read outlets first, one per outlet before any repeats',
  },
  // 'Recent', not 'Newest' (Sam, 2026-10-24); the id stays for analytics.
  { id: 'newest', label: 'Recent', title: 'Most recently published first' },
]
export const DEFAULT_ORDER = 'popular'

// A live blog is a container, not a framing: "Live updates: Trump to speak
// at the UN" says nothing about how that outlet saw the speech. Sorted to
// the back rather than dropped, so a side covered only by a live blog still
// appears.
const LIVE_BLOG = /^live (updates|blog|coverage)\b/i

function byRank(a, b) {
  const live =
    Number(LIVE_BLOG.test(a.title || '')) -
    Number(LIVE_BLOG.test(b.title || ''))
  if (live) return live
  const pop = (b.outlet?.popularity || 0) - (a.outlet?.popularity || 0)
  if (pop) return pop
  return (b.outlet?.reliability || 0) - (a.outlet?.reliability || 0)
}

function byNewest(a, b) {
  return String(b.published_date || '').localeCompare(
    String(a.published_date || '')
  )
}

export function rankArticles(list = [], order = DEFAULT_ORDER) {
  if (order === 'newest') return [...list].sort(byNewest)
  const sorted = [...list].sort(byRank)
  // One article per outlet first, then the rest (in the same order). Eight
  // slots ranked by outlet alone gave a column Fox News four times over —
  // true, but a masthead repeated is a slot spent saying nothing new.
  const seen = new Set()
  const first = []
  const rest = []
  for (const a of sorted) {
    const key = a.outlet?.slug || a.outlet?.name
    if (key && seen.has(key)) rest.push(a)
    else {
      if (key) seen.add(key)
      first.push(a)
    }
  }
  return [...first, ...rest]
}
